import { useNavigate } from "react-router";
import dynamicfunction from "../../utils/dynamicfunction";
import { useSelector } from "react-redux";
import { getContentKeyAccToLang } from "../../utils/utils";

export default () => {
  const navigate = useNavigate();
  const { TextWeight, isArabic } = dynamicfunction();
  
  const accountOpeningData = useSelector((state) => state.content?.accountOpeningData);

  const dashboardContent = useSelector((state) => state.content?.dashboardContent);

  const getContentKey = (key) => {
    return getContentKeyAccToLang(dashboardContent, key, isArabic);
  };

  return { TextWeight, navigate, accountOpeningData, isArabic, getContentKey };
};
